
//import mixpanel from 'mixpanel-browser'
import { MIXPANEL_TOKEN } from '../../../config/environment'

//mixpanel.init(MIXPANEL_TOKEN)

const mixpanel = {
	track: () => {},
}

export default mixpanel


// WEBPACK FOOTER //
// ./src/store/services/mixpanel/index.js